import { render, staticRenderFns } from "./GenericExportColumns.vue?vue&type=template&id=28ced9d5&scoped=true"
import script from "./GenericExportColumns.vue?vue&type=script&lang=js"
export * from "./GenericExportColumns.vue?vue&type=script&lang=js"
import style0 from "./GenericExportColumns.vue?vue&type=style&index=0&id=28ced9d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ced9d5",
  null
  
)

export default component.exports